import { z } from "zod";

/**
 * Clip sizes a bot can be allowed to make, smallest first, as the bot's `videoSizes` stores
 * them. Providers support a subset.
 */
export const VIDEO_SIZES = ["480p", "720p", "1080p", "1k", "2k", "4k"] as const;
export const VideoSizeSchema = z.enum(VIDEO_SIZES);
export type VideoSize = z.infer<typeof VideoSizeSchema>;

/** The longest clip make_video asks for; providers may allow less. */
export const MAX_VIDEO_DURATION_SECONDS = 15;

/**
 * A bot's "Make videos" abilities, read from the bot (see readBotVideoSettings). Everything
 * reads as off until the bot settings columns exist.
 */
export interface BotVideoSettings {
  enabled: boolean;
  /** The bot's own video model; null follows the member's video model for the Space. */
  model: { provider: string; modelId: string; credentialId: string | null } | null;
  /** Sizes this bot may make; empty allows every size its model supports. */
  sizes: VideoSize[];
  /** Every clip waits for the owner's approval before anything is spent. */
  approveEach: boolean;
  /** Most clips per day, counted in the owner's time zone; null means no clip cap. */
  dailyClipCap: number | null;
}

export const DEFAULT_BOT_VIDEO_SETTINGS: BotVideoSettings = {
  enabled: false,
  model: null,
  sizes: [],
  approveEach: false,
  dailyClipCap: null,
};
